import styled from 'styled-components';

const FeedbackMessageWrapper = styled.div`
  min-height: 2rem;
  margin-top: 0.4rem;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 1.2rem;
  line-height: 1.4rem;
`;

FeedbackMessageWrapper.displayName = 'FeedbackMessageWrapper';

export default FeedbackMessageWrapper;
